<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">Exhibition List</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span class="px-0">Other Events</span><span>/</span
            ><span
              @click.prevent="toEventMain"
              style="color: #1a73e8"
              class="pointer px-0"
              >{{ EventName }}</span
            ><span>/</span
            ><a href="javascript:history.back()">Select Promotional Product</a
            ><span>/</span>Add Promotional Product
          </div>
          <div>
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>Add Promotional Product</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              Do not upload content that is irrelevant to this exhibition. The
              organizer reserves the right to delete inappropriate content.
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">Product Name</p>
              <p>
                {{ ProductDetail.ProName }}
              </p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Category <span class="red">*</span></p>
              <div class="form-row">
                <div class="form-group col-md-2">
                  <select
                    class="form-control text-dark"
                    v-model="mCatID"
                    required
                  >
                    <option value="">-- Select --</option>
                    <option v-for="item in EventCatList" :value="item.mCatID">
                      {{ item.emCatName }}
                    </option>
                  </select>
                </div>
              </div>

              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <div v-if="inputDescHidden == 0">
                <p class="formTitle">
                  {{ einputDescName }}
                  <span class="red" v-if="inputDescRequired == 0">*</span>
                </p>
                <div class="langTip">
                  <input
                    type="text"
                    name="Desc"
                    class="maxText textStyle inputDescRe"
                    maxlength="20"
                    v-model="ereg_Desc"
                  />
                  <span>En </span>
                </div>
                <div class="blueBG mt-1">{{ einputDescNotes }}</div>

                <div class="langTip mt-2">
                  <input
                    type="text"
                    name="Desc"
                    class="maxText textStyle inputDescReCn"
                    maxlength="20"
                    v-model="reg_Desc"
                  />
                  <span>中 </span>
                </div>
                <div class="blueBG mt-1">{{ inputDescNotes }}</div>

                <p class="my-3">&nbsp;</p>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <p class="formTitle">
                  {{ einputDescName2 }}
                  <span class="red" v-if="inputDescRequired2 == 0">*</span>
                </p>

                <div class="langTip">
                  <input
                    type="text"
                    name="Desc2"
                    class="maxText textStyle inputDescRe2"
                    maxlength="20"
                    v-model="ereg_Desc2"
                  />
                  <span>En </span>
                </div>
                <div class="blueBG mt-1">{{ einputDescNotes2 }}</div>

                <div class="langTip mt-2">
                  <input
                    type="text"
                    name="Desc2"
                    class="maxText textStyle inputDescRe2Cn"
                    maxlength="20"
                    v-model="reg_Desc2"
                  />
                  <span>中 </span>
                </div>
                <div class="blueBG mt-1">{{ inputDescNotes2 }}</div>

                <p class="my-3">&nbsp;</p>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  Launch Date
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle inputOnlineDateRe"
                    maxlength="20"
                    v-model="reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  Original Price (NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle inputPriceRe"
                    maxlength="20"
                    v-model="reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  Exhibition Exclusive Price (NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle inputDiscountPriceRe"
                    maxlength="20"
                    v-model="reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>
              <div class="d-flex justify-content-center">
                <input type="submit" value="Send" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backSelectPro">
                  Back
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title:
        "Add Promotional Product - Chan Chao Exhibitor Online Service System",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      ProductID: "",
      ProductDetail: {},
      reg_Desc: "",
      reg_Desc2: "",

      ereg_Desc: "",
      ereg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventDetail: {},
      EventCatList: [],
      mCatID: "",
      eventId: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      inputDescRequired: "",
      inputDescNotes: "",
      inputDescName2: "",
      inputDescHidden2: "",
      inputDescRequired2: "",
      inputDescNotes2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
    };
  },

  watch: {},

  methods: {
    toEventMain() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
    AddPromotionPro() {
      const vm = this;
      const url = "/apiExhibitors/MarketingEventRegister/";

      const info = {
        regNo: vm.RegNo,
        eventId: vm.eventId,
        proNo: vm.ProductID,
        mCatID: vm.mCatID,
        reg_Desc: vm.reg_Desc,
        reg_Desc2: vm.reg_Desc2,
        ereg_Desc: vm.ereg_Desc,
        ereg_Desc2: vm.ereg_Desc2,

        reg_LaunchDate: vm.reg_LaunchDate,
        reg_Price: vm.reg_Price,
        reg_DiscountPrice: vm.reg_DiscountPrice,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        // console.log(response)
        if (response.data.Code == 200) {
          alert("You have successfully registered.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 500) {
          alert("The system is busy. Please try again later.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 252) {
          document.location.href = `https://www.chanchao.com.tw/`;
        } else if (response.data.Code == 253) {
          alert(
            "The exhibitor code of the registration form does not match the activity."
          );
        } else if (response.data.Code == 254) {
          alert(
            "The registration number and the selected product belong to different exhibitors."
          );
        } else if (response.data.Code == 255) {
          alert(
            "Registration time is outside the allowed timeframe for this exhibitor activity."
          );
        } else if (response.data.Code == 256) {
          alert(
            "The number of booths in your registration is less than the minimum required for this activity."
          );
        } else if (response.data.Code == 257) {
          alert(
            "You have exceeded the allowed number of registrations for this activity."
          );
        } else if (response.data.Code == 258) {
          alert(
            "The selected product has already been registered for this activity."
          );
        }
      });
    },

    backSelectPro() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.ProductID = currentUrl.split("id=")[1].split("&")[0];
    vm.eventId = currentUrl.split("eventId=")[1];

    let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`;
    axios.get(url).then(function (response) {
      // console.log(response.data.Data)
      vm.ProductDetail = response.data.Data;
    });

    //取得線上展總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.EventDetail = response.data.Data;
        vm.EventCatList = response.data.Data.category;

        // 欄位顯示判定

        vm.inputDescHidden = response.data.Data.inputDescHidden;
        vm.inputDescHidden2 = response.data.Data.inputDescHidden2;
        vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden;
        vm.inputPriceHidden = response.data.Data.inputPriceHidden;
        vm.inputDiscountPriceHidden =
          response.data.Data.inputDiscountPriceHidden;

        vm.inputDescName = response.data.Data.inputDescName;
        vm.einputDescName = response.data.Data.einputDescName;

        vm.inputDescName2 = response.data.Data.inputDescName2;
        vm.einputDescName2 = response.data.Data.einputDescName2;

        vm.inputDescNotes = response.data.Data.inputDescNotes;
        vm.inputDescNotes2 = response.data.Data.inputDescNotes2;

        vm.einputDescNotes = response.data.Data.einputDescNotes;
        vm.einputDescNotes2 = response.data.Data.einputDescNotes2;

        //必填

        vm.inputDescRequired = response.data.Data.inputDescRequired;
        vm.inputDescRequired2 = response.data.Data.inputDescRequired2;
        vm.inputOnlineDateRequired = response.data.Data.inputOnlineDateRequired;
        vm.inputPriceRequired = response.data.Data.inputPriceRequired;
        vm.inputDiscountPriceRequired =
          response.data.Data.inputDiscountPriceRequired;

        if (vm.inputDescRequired == 0) {
          $(".inputDescRe")[0].setAttribute("required", "true");
          $(".inputDescReCn")[0].setAttribute("required", "true");
        }
        if (vm.inputDescRequired2 == 0) {
          $(".inputDescRe2")[0].setAttribute("required", "true");
          $(".inputDescRe2Cn")[0].setAttribute("required", "true");
        }
        if (vm.inputOnlineDateRequired == 0) {
          $(".inputOnlineDateRe")[0].setAttribute("required", "true");
        }
        if (vm.inputPriceRequired == 0) {
          $(".inputPriceRe")[0].setAttribute("required", "true");
        }
        if (vm.inputDiscountPriceRequired == 0) {
          $(".inputDiscountPriceRe")[0].setAttribute("required", "true");
        }

        vm.EventName = response.data.Data.eEventName;

        // 開啟時間判定
        let OpenRegiterDate = response.data.Data.backEndStartDate;
        let CloseRegiterDate = response.data.Data.backEndEndDate;
        let Nowdate = Date.parse(new Date()).valueOf();

        if (Nowdate < OpenRegiterDate) {
          alert("The activity has not yet started.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (Nowdate > CloseRegiterDate) {
          alert("The activity has not yet started.");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
  },
};
</script>

<style lang="scss"></style>
